import React, { useEffect, useState } from 'react';
import api from '../../config/axios';
import Swal from 'sweetalert2';

import ServicoModal from './modals/Servico';
import CategoriaModal from './modals/Categoria';

import '../../assets/styles/colaboradores.css';
import { FaPlus, FaEdit, FaFilter } from 'react-icons/fa';
import Paginacao from '../../components/utils/paginacao';

const Servicos = () => {
  const [error, setError] = useState(null);

  const [servicos, setServicos] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [colaboradores, setColaboradores] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [userType, setUserType] = useState('');

  const [selectedServico, setSelectedServico] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCategoriaOpen, setIsModalCategoriaOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const getColaboradores = async () => {
    const response = await api.get(`/pessoas/colaboradores?page=1&limit=200`);

    setColaboradores(response.data.colaboradores || []);
  };

  const getCategorias = async () => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await api.get(`/categorias`);

      setCategorias(response.data.records || []);
      setError(null);
      Swal.close();
    } catch (err) {
      Swal.close();
      setError('Erro ao carregar a lista de categorias.');
    }
  };

  const fetchServicos = async (currentPage) => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await api.get(`/servicos?page=${currentPage}&limit=${limit}&nome=${filtroNome}`);

      setServicos(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
      Swal.close();
    } catch (err) {
      Swal.close();
      setError('Erro ao carregar a lista de serviços.');
    }
  };

  useEffect(() => {
    const fetchUserType = async () => {
      try {
        const userDataArmazenado = localStorage.getItem('userData');
        
        if (userDataArmazenado) {
          const userData = JSON.parse(userDataArmazenado);
          
          if (userData.unidade_designacao_id && userData.gestora_designacao_id) {
            setUserType('colaborador');
          } else if (userData.gestora_designacao_id) {
            setUserType('gestor');
          } else {
            setUserType('master');
          }
          return;
        }
      } catch (error) {
        setUserType('colaborador');
      }
    };
    
    const fetchData = async () => {
      await fetchUserType();
      if (!colaboradores.length) await getColaboradores();
      if (!categorias.length) await getCategorias();
      fetchServicos(currentPage);    
    };

    fetchData();
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddCategoria = () => {
    setIsModalCategoriaOpen(true);
  };

  const handleAddServico = () => {
    setSelectedServico(null);
    setIsModalOpen(true);
  };

  const handleEditServico = (servico) => {
    setSelectedServico(servico);
    setIsModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchServicos(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
  };


  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Serviços</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-8 col-12">
              {(userType === 'master' || userType === 'gestor') && (
                <>
                  <button className="btn btn-outline-primary" onClick={handleAddServico}>
                    <FaPlus /> Adicionar Serviço
                  </button>
                  <button className="btn btn-outline-primary ms-3" onClick={handleAddCategoria}>
                    <FaPlus /> Adicionar Categoria
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-4 col-md-6 col-12">
              <label className="form-label fw-bold">Nome do Serviço</label>
              <input
                type="text"
                placeholder="Digite o nome do serviço"
                autoComplete="off"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-8 col-md-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="table-custom-primary">
                    <tr>
                      <th>Serviço</th>
                      <th>Categoria</th>
                      <th>Descrição</th>
                      <th>Duração</th>
                      <th>Valor</th>
                      <th>Custo do Serviço</th>
                      <th className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {servicos.map((servico) => (
                      <tr key={servico.id_servico}>
                        <td className="text-nowrap">{servico.nome}</td>
                        <td className="text-nowrap">{categorias.find(x => x.id == servico.id_categoria).nome}</td>
                        <td style={{ width: "700px" }}>{servico.descricao}</td>
                        <td>{servico.tempo.split(':').slice(0, 2).join(':')}</td>
                        <td className="text-nowrap">{parseFloat(servico.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                        <td className="text-nowrap">{parseFloat(servico.custo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                        <td className="text-nowrap text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditServico(servico)}
                          >
                            <FaEdit />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {isModalOpen && (
          <ServicoModal
            servico={selectedServico}
            categoriasLista={categorias}
            colaboradoresLista={colaboradores}
            onClose={() => setIsModalOpen(false)}
            onServicoAtualizado={() => fetchServicos(currentPage)}
          />
        )}

        {isModalCategoriaOpen && (
          <CategoriaModal
            categoriaLista={categorias}
            onClose={() => setIsModalCategoriaOpen(false)}
            onCategoriaAtualizado={() => getCategorias()}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Servicos;
